import { render, staticRenderFns } from "./DialogAddExpoChapter.vue?vue&type=template&id=245d259c"
import script from "./DialogAddExpoChapter.vue?vue&type=script&lang=js"
export * from "./DialogAddExpoChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245d259c')) {
      api.createRecord('245d259c', component.options)
    } else {
      api.reload('245d259c', component.options)
    }
    module.hot.accept("./DialogAddExpoChapter.vue?vue&type=template&id=245d259c", function () {
      api.rerender('245d259c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddExpoChapter.vue"
export default component.exports